// extracted by mini-css-extract-plugin
export default {"container":"Separator_container__Yrg+0","text":"Separator_text__WzSVu","line":"Separator_line__qNgY9"};